export const backgroundColorDefault = '#263846'
export const backgroundColorLight = '#40c1ac'

export const headerBgColor = '#263846'
export const appTextColor = '#ffffff'
export const cardBgColor = '#40c1ac'
